import React, { useState, useContext, useEffect, useRef, Component } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
}));

const AdminLayout = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <CssBaseline />

            {children}
        </div>
    )
}

export default AdminLayout;